import { lazy, ReactElement, Suspense } from "react";
import { Redirect } from "react-router";
import { useParams } from "react-router";
import { useConfig } from "../../contexts/ConfigContext";
import ResonanceLoader from "../../components/atoms/ResonanceLoader/ResonanceLoader";
import { getProjectConfig } from "../../projects";
import { getDefaultTabPath } from "../../navigation/studyTabs";

// Home experiences are lazy modules so a study only ships the one it uses.
const MountainHome = lazy(() => import("../../modules/mountain/MountainHome"));
const IslandMap = lazy(() =>
  import("../MentalPlusPages").then((m) => ({ default: m.IslandMap }))
);

/**
 * The "home" tab dispatcher. Which experience renders is per-study:
 * - is_gamified (DB flag)          -> legacy Mentalo mountain
 * - project homeExperience         -> 'island-map' (Mental+) or none
 * Studies without a home experience just land on their default tab.
 * Mounting DISTINCT components per experience (instead of branching inside one)
 * also keeps hook order stable.
 */
const LoguedHome = (): ReactElement => {
  const { study, selectedRole } = useConfig();
  const { study_slug } = useParams<{ study_slug: string }>();

  if (study.is_gamified) {
    return (
      <Suspense fallback={<ResonanceLoader />}>
        <MountainHome />
      </Suspense>
    );
  }

  if (getProjectConfig(study_slug).homeExperience === "island-map") {
    return (
      <Suspense fallback={<ResonanceLoader />}>
        <IslandMap />
      </Suspense>
    );
  }

  return <Redirect to={getDefaultTabPath(study_slug, selectedRole?.name)} />;
};

export default LoguedHome;
